import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "13",
  fill: "none",
  viewBox: "0 0 20 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.586 12.219c.523 0 .789-.219.96-.766l.876-2.437h4.46l.868 2.437c.172.547.445.766.96.766.548 0 .9-.328.9-.844 0-.187-.032-.344-.102-.555L7.047 1.477C6.805.82 6.367.5 5.657.5c-.68 0-1.126.32-1.352.969L.82 10.859c-.07.204-.101.368-.101.532 0 .515.328.828.867.828M3.867 7.57l1.766-5.078h.047L7.445 7.57zm11.024 4.696c1.18 0 2.297-.633 2.78-1.633h.032v.883c.008.468.328.757.781.757.47 0 .79-.296.79-.82V6.297c0-1.727-1.313-2.844-3.383-2.844-1.586 0-2.852.649-3.297 1.68a1.3 1.3 0 0 0-.133.539c0 .398.289.664.703.664.29 0 .508-.11.664-.352.461-.851 1.07-1.234 2.008-1.234 1.133 0 1.82.633 1.82 1.664v.64l-2.437.141c-2.055.11-3.188 1.032-3.188 2.532 0 1.515 1.18 2.539 2.86 2.539m.437-1.25c-.984 0-1.656-.54-1.656-1.352 0-.781.625-1.297 1.765-1.367l2.22-.149v.79c0 1.171-1.032 2.078-2.329 2.078"
    }, null, -1)
  ])))
}
export default { render: render }